import React, { useState, useContext } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { AppBar, Toolbar, IconButton, Typography, Button, TextField, Backdrop, CircularProgress, Fab, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext.js';
import { HttpService } from "../../../apiAuthorization/httpService";
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import GridItem from "../../grid/gridItem.js";
import GridContainer from "../../grid/gridContainer.js";
import AlertDialog from '../../common/alertDialog';
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);

export default function AddUser(props) {
    const classes = useStyles();
    const users = props.users;
    const { theme } = useContext(Theme);
    const [selectedUser, setSelectedUser] = useState(0);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [severity, setSeverity] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const [backDrop, setBackDrop] = useState(false);
    const [modified, setModified] = useState(false);
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);

    const alertClose = () => {
        setAlertOpen(false);
    };

    const saveUser = (goBack) => {
        if (backDrop) {
            return;
        }
        else if (selectedUser) {
            setBackDrop(true);
            HttpService.post("/User/AddAppUser", { Username: selectedUser.userName })
            .then((result) => {
                if (result.error) {
                    setBackDrop(false);
                    setErrorMessage(result.message);
                    setSeverity('error');
                    setAlertOpen(true);
                }
                else {
                    var user = selectedUser;
                    user.id = result.data.AppUserId;
                    user.userGroup = result.data.Group;
                    props.refreshGrid(user);
                    props.parentCallback();
                }
            });
        }
        else if (goBack) {
            props.parentCallback();
        }
    };
  
    return (<>
        <Backdrop className={classes.backdrop} id="userAddBackdrop" open={backDrop}>
            <CircularProgress color="inherit" />
        </Backdrop>
        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
            <Toolbar>
                <IconButton edge="start" color="inherit" onClick={() => saveUser(true)} aria-label="back">
                    <KeyboardBackspaceIcon />
                </IconButton>
                <Grid container direction="row" alignItems="center">
                    <Grid item>
                        <Typography variant="h6" className={classes.title}>Add User</Typography>
                    </Grid>
                    <Grid item>
                        <StatusIcon />
                    </Grid>
                </Grid>
                <Grid container justify="flex-end">
                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="close" onClick={props.parentCallback}>
                        <CloseIcon />
                    </Fab>
                    <SmallMenu modified={modified} saveCallback={() => saveUser(false)} />
                </Grid>
            </Toolbar>
        </AppBar>
        <GridContainer style={{ justifyContent: 'center' }}>
            <GridItem xs={6} sm={6} md={6}>
                <Card style={{ backgroundColor: currentTheme.background }}>
                    <CardBody style={{ color: currentTheme.text, marginTop: "50px", display: 'flex', justifyContent: 'center' }}>
                        <ValidatorForm className={classes.root} autoComplete="off" style={{ width: "100%", display: "block" }} onSubmit={() => saveUser(false)}>
                            <Autocomplete
                                id="user"
                                options={users}
                                getOptionLabel={(option) => option.userName}
                                onChange={(event, value) => {
                                    setSelectedUser(value);
                                    setModified(true);
                                }}
                                style={{ width: "100%", clear: "both" }}
                                renderInput={(params) => <TextField {...params} label="Select User Name" variant="outlined" />}
                            />
                            <br></br>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className={classes.button}
                                style={{ background: currentTheme.secondary, width: "100px", float: 'right' }}
                                startIcon={<SaveIcon />}
                                type="submit"
                            >
                                Save
                            </Button>
                        </ValidatorForm>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
        <AlertDialog open={alertOpen} close={alertClose} message={errorMessage} severity={severity} />
    </>
    );
}
